import { licenseCheckLatestStatusEntityName } from '../../../../backend/features/credentialing-verification/shared';
export function filterDataToAccountFilter(filterData) {
    const accountFilter = [];
    const licenseCheckLatestStatusFilter = [
        {
            column: 'jasBoard',
            op: '=',
            value: true,
        },
    ];
    if (filterData.search) {
        licenseCheckLatestStatusFilter.push({ column: 'search', op: 'full-text-query', value: filterData.search });
    }
    if (filterData.occupationIds) {
        licenseCheckLatestStatusFilter.push({
            column: 'occupationId',
            op: 'in',
            value: filterData.occupationIds,
        });
    }
    if (filterData.credentialNames) {
        licenseCheckLatestStatusFilter.push({
            column: 'credentialName',
            op: 'in',
            value: filterData.credentialNames,
        });
    }
    if (filterData.statuses) {
        licenseCheckLatestStatusFilter.push({
            column: 'status',
            op: 'in',
            value: filterData.statuses,
        });
    }
    if (filterData.city) {
        accountFilter.push({
            column: 'city',
            op: '=',
            value: filterData.city,
        });
    }
    if (filterData.state) {
        accountFilter.push({
            column: 'state',
            op: '=',
            value: filterData.state,
        });
    }
    if (filterData.county) {
        accountFilter.push({
            column: 'county',
            op: '=',
            value: filterData.county,
        });
    }
    if (filterData.tribeId) {
        accountFilter.push({
            column: 'tribeId',
            op: '=',
            value: filterData.tribeId,
        });
    }
    if (filterData.loginBefore) {
        licenseCheckLatestStatusFilter.push({
            column: 'requestDate',
            op: '<=',
            value: filterData.loginBefore,
        });
    }
    if (filterData.loginAfter) {
        licenseCheckLatestStatusFilter.push({
            column: 'requestDate',
            op: '>=',
            value: filterData.loginAfter,
        });
    }
    if (filterData.requestedBy) {
        licenseCheckLatestStatusFilter.push({
            column: 'requestedBy',
            op: '=',
            value: filterData.requestedBy,
        });
    }
    if (filterData.ecls) {
        accountFilter.push({
            column: 'ecls',
            op: 'overlap',
            value: filterData.ecls,
        });
    }
    if (filterData.occupationGroupId) {
        accountFilter.push({
            column: 'occupationGroups',
            op: '=',
            value: filterData.occupationGroupId,
        });
    }
    return [
        {
            op: 'in',
            idSubFilter: {
                entity: licenseCheckLatestStatusEntityName,
                column: 'personId',
                filter: licenseCheckLatestStatusFilter,
            },
        },
        ...accountFilter,
    ];
}
